/**
 * DEWA Electrical Safety - Quiz Definitions (Arabic)
 *
 * Arabic translation of quizzes.js - structure and logic values are identical.
 */

export const moduleQuizzes = {
  'quiz-electrical-safety': {
    intro: "هيا نختبر فهمك لأساسيات السلامة الكهربائية. سأقرأ كل سؤال مع 4 خيارات. يرجى النقر على إجابتك على الشاشة - الإجابات الصوتية غير مدعومة في الاختبارات.",
    questions: [
      {
        question: "ما هو الحد الأدنى لمستوى الجهد الكهربائي الذي يُعتبر عموماً خطيراً على الإنسان؟",
        options: [
          "5 فولت",
          "50 فولت",
          "220 فولت",
          "1000 فولت"
        ],
        correctIndex: 1,
        explanation: "يمكن أن تكون الجهود المنخفضة حتى 50 فولت تيار متردد قاتلة في ظروف معينة، مثل البشرة المبللة أو مسار التيار المباشر عبر القلب. لهذا السبب حتى الأنظمة منخفضة الجهد تتطلب الحذر."
      },
      {
        question: "ما هي الخطوة الأولى قبل العمل على أي معدات كهربائية؟",
        options: [
          "ارتداء القفازات المطاطية",
          "إبلاغ المشرف",
          "التأكد من فصل الدائرة عن الطاقة وتطبيق إجراء القفل والعلامة",
          "التحقق من أحوال الطقس"
        ],
        correctIndex: 2,
        explanation: "إجراء القفل والعلامة (LOTO) هو الخطوة الأولى الأكثر أهمية. يجب التحقق من فصل الدائرة عن الطاقة قبل بدء أي عمل لمنع التشغيل العرضي."
      }
    ],
    passingScore: 1,
    completionMessage: "عمل رائع! أنت تفهم أساسيات السلامة الكهربائية. هيا نستمر في التعرف على معدات الوقاية الشخصية وقواعد دخول الموقع."
  },

  'quiz-ppe': {
    intro: "الآن لنختبر معرفتك بمعدات الوقاية الشخصية وقواعد دخول الموقع. سأقرأ كل سؤال مع 4 خيارات. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "أي مما يلي ليس من معدات الوقاية الشخصية القياسية المطلوبة لدخول محطة فرعية تابعة لديوا؟",
        options: [
          "خوذة أمان مع حزام ذقن",
          "أحذية أمان معزولة",
          "نظارات شمسية",
          "سترة عالية الوضوح"
        ],
        correctIndex: 2,
        explanation: "تشمل معدات الوقاية الشخصية القياسية لدخول المحطة الفرعية خوذة أمان وأحذية معزولة وسترة عالية الوضوح وملابس مقاومة للوميض القوسي. النظارات الشمسية العادية لا تُعتبر من معدات الوقاية الشخصية."
      },
      {
        question: "ماذا يجب أن تفعل قبل دخول منطقة كهربائية مقيدة؟",
        options: [
          "التقاط صورة للتوثيق",
          "الحصول على تصريح عمل صالح (PTW)",
          "الاتصال بغرفة التحكم للتحية",
          "التحقق من إشارة الهاتف المحمول"
        ],
        correctIndex: 1,
        explanation: "تصريح العمل (PTW) إلزامي قبل دخول أي منطقة كهربائية مقيدة. يضمن الحصول على التفويض المناسب وتقييم المخاطر وتدابير السلامة المطلوبة."
      }
    ],
    passingScore: 1,
    completionMessage: "ممتاز! أنت الآن تفهم متطلبات معدات الوقاية الشخصية وقواعد دخول الموقع. هيا نستكشف العمل داخل المحطات الفرعية."
  },

  'final-quiz': {
    intro: "هذا هو الاختبار النهائي لتقييم معرفتك الشاملة بالسلامة الكهربائية. سأقرأ كل سؤال مع 4 خيارات. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "ما هي مسافة الاقتراب الآمنة لموصل مكهرب بجهد 33 كيلو فولت؟",
        options: [
          "0.5 متر",
          "1 متر",
          "3 أمتار",
          "10 أمتار"
        ],
        correctIndex: 2,
        explanation: "بالنسبة لأنظمة 33 كيلو فولت، يجب الحفاظ على مسافة اقتراب آمنة لا تقل عن 3 أمتار تقريباً. تزداد هذه المسافة مع مستويات الجهد الأعلى لمنع الوميض القوسي والصعق الكهربائي."
      },
      {
        question: "أثناء حالة طوارئ في المحطة الفرعية، ما هو الترتيب الصحيح للإجراءات؟",
        options: [
          "إصلاح المشكلة ثم الإبلاغ عنها",
          "الإخلاء، تنبيه الآخرين، الإبلاغ لغرفة التحكم",
          "التقاط صور أولاً ثم الإخلاء",
          "الاتصال بالمدير والانتظار للتعليمات"
        ],
        correctIndex: 1,
        explanation: "في أي حالة طوارئ بالمحطة الفرعية، السلامة الشخصية تأتي أولاً. قم بإخلاء المنطقة فوراً، ونبّه الموظفين القريبين، وأبلغ غرفة التحكم للاستجابة المنسقة."
      }
    ],
    passingScore: 1,
    completionMessage: "تهانينا! لقد أكملت دورة السلامة الكهربائية في ديوا. أنت الآن تفهم مبادئ السلامة الحيوية للعمل مع الأنظمة الكهربائية في منشآت ديوا."
  },
};

export const finalQuiz = {
  intro: "هذا هو التقييم النهائي. لنرى كم تعلمت عن السلامة الكهربائية في ديوا.",
  questions: [
    {
      question: "ما هي إجراءات السلامة الثلاثة الرئيسية قبل العمل على المعدات الكهربائية؟",
      correctAnswer: "القفل، العلامة، والاختبار (LOTO + التحقق)",
      keywords: ["قفل", "علامة", "loto", "تحقق", "اختبار", "فصل الطاقة"],
      topic: "أساسيات السلامة الكهربائية"
    },
    {
      question: "ما هي معدات الوقاية الشخصية الإلزامية لدخول المحطة الفرعية؟",
      correctAnswer: "خوذة أمان، أحذية معزولة، سترة عالية الوضوح، ملابس مقاومة للوميض القوسي",
      keywords: ["خوذة", "أحذية", "معزولة", "وميض قوسي", "عالية الوضوح", "سترة"],
      topic: "متطلبات معدات الوقاية الشخصية"
    }
  ],
  passingScore: 1,
  completionMessage: "تهانينا! لقد أكملت دورة السلامة الكهربائية في ديوا. ابقَ آمناً واتبع دائماً الإجراءات الصحيحة."
};

const dewaQuizzesAr = {
  moduleQuizzes,
  finalQuiz,
};

export default dewaQuizzesAr;
